import styled, { css } from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  height: var(--cp-btn-height, 30px);
  padding: var(--cp-btn-padding, 0 15px);
  /* v2: modern rounded-rect; v1: legacy pill (via the var fallback) */
  border-radius: var(--cp-btn-radius, 40px);
  justify-content: center;
  align-items: center;
  line-height: 1;
  border: none;
  outline: none;
  white-space: nowrap;
  font-weight: var(--cp-btn-weight, 400);
  box-shadow: var(--cp-btn-shadow, 0 1px 1px 0 rgba(0, 0, 0, 0.5), inset 0 0px 30px 0 rgba(0, 0, 0, 0));
  transition:
    transform 0.12s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.18s ease,
    filter 0.15s ease,
    background 0.18s ease;
  /* crisp label on coloured fills (v2 fixes the "muddy" white text) */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
  display: ${(props) => (props.invisible ? 'none' : 'flex')};
  opacity: ${(props) => (props.disabled ? '0.4' : '1')};
  color: ${(props) => props.theme.color};
  background-color: ${(props) => props.theme.bgColor ?? '#ccc'};
  /* subtle depth + deeper bottom edge → better white-text contrast (v2 only) */
  background-image: var(--cp-btn-overlay, none);
  /* crisp, high-contrast label on coloured fills — kills the "muddy" look
     (v2 only; v1 falls back to none via the var) */
  letter-spacing: var(--cp-btn-letter-spacing, normal);
  text-shadow: var(--cp-btn-text-shadow, none);
  img,
  i {
    margin-right: 5px;
  }
  &:hover {
    box-shadow: var(--cp-btn-shadow-hover, 0 1px 1px 0 rgba(0, 0, 0, 0.5), inset 0 0px 30px 0 rgba(0, 0, 0, 0.3));
    filter: var(--cp-btn-hover-filter, none);
    transform: var(--cp-btn-hover-transform, none);
  }
  &:active {
    transform: var(--cp-btn-active-transform, none);
  }
  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
  &.loading {
    opacity: 1;
    position: relative;
  }
  &.loading:after {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    /* z-index: 999; */
    border-radius: 4px;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.75) url(/images/loader.svg) no-repeat 50%;
  }
`;

// default theme
Button.defaultProps = {
  theme: {
    color: '#000',
    bgColor: '#dbdbdb',
  },
};

export const SquareButton = styled(Button)`
  height: 80px;
  width: 500px;
  padding: 0;
  border-radius: 4px;
  font-size: 26px;
  img,
  i {
    margin-right: 25px;
  }
`;

export const GradientButton = styled(Button)`
  background: ${(props) => props.theme.bg};
  border: solid 1px ${(props) => props.theme.border};
  ${(props) =>
    props.theme.theme !== 'dark' &&
    css`
      border-color: ${(props) => props.theme.borderLight ?? props.theme.border};
    `}
`;

export const SimpleButton = styled(Button)`
  cursor: pointer;
  font-size: 15px;
  color: var(--cp-accent, #3ea5ff);
  padding: 0.5em 0;
  border: 0;
  box-shadow: none;
  background: none;
  transform: none;
  i {
    margin-right: 5px;
  }
  &:hover {
    color: #fff;
    background: none;
    box-shadow: none;
    transform: none;
    ${(props) =>
      props.theme.ui === 'v2' &&
      css`
        color: var(--cp-accent-hover);
      `}
  }
  &:active {
    transform: none;
  }
`;

export const Reset = styled.div`
  position: relative;
  padding-left: 24px;
  height: 40px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  font-size: 15px;
  color: var(--cp-accent, #3ea5ff);
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
  &:before,
  &:after {
    content: ' ';
    position: absolute;
    left: 10px;
    top: 10px;
    height: 20px;
    width: 2px;
    background-color: var(--cp-accent, #0085ef);
  }
`;
